export interface ShareInput {
  url: string;
  card: Blob | null;
}

export interface SharePlatform {
  canShareFiles(card: File): boolean;
  share(data: ShareData): Promise<void>;
  canWriteClipboard(): boolean;
  writeClipboard(value: string): Promise<void>;
}

export type ShareResult =
  | { kind: 'shared'; message: '已打开系统分享，请选择微信好友' }
  | { kind: 'copied'; message: '链接已复制，请粘贴发给 TA' }
  | { kind: 'manual'; message: '请长按复制下方完整链接' };

export async function shareInteraction(
  input: ShareInput,
  platform: SharePlatform,
): Promise<ShareResult> {
  const card = input.card === null
    ? null
    : input.card instanceof File
      ? input.card
      : new File([input.card], 'ticket-card.jpg', { type: input.card.type || 'image/jpeg' });
  if (card && platform.canShareFiles(card)) {
    try {
      await platform.share({
        title: '两小只',
        text: '有一张单据等你回应',
        url: input.url,
        files: [card],
      });
      return { kind: 'shared', message: '已打开系统分享，请选择微信好友' };
    } catch {
      // A cancelled or unavailable share sheet still leaves clipboard/manual paths.
    }
  }
  if (platform.canWriteClipboard()) {
    try {
      await platform.writeClipboard(input.url);
      return { kind: 'copied', message: '链接已复制，请粘贴发给 TA' };
    } catch {
      // Keep the full URL visible so the manual path remains usable.
    }
  }
  return { kind: 'manual', message: '请长按复制下方完整链接' };
}

export function createBrowserSharePlatform(navigatorValue: Navigator = navigator): SharePlatform {
  return {
    canShareFiles(card) {
      try {
        return typeof navigatorValue.share === 'function'
          && typeof navigatorValue.canShare === 'function'
          && navigatorValue.canShare({ files: [card] });
      } catch {
        return false;
      }
    },
    share(data) {
      if (typeof navigatorValue.share !== 'function') return Promise.reject(new Error('share unavailable'));
      return navigatorValue.share(data);
    },
    canWriteClipboard() {
      return typeof navigatorValue.clipboard?.writeText === 'function';
    },
    writeClipboard(value) {
      if (typeof navigatorValue.clipboard?.writeText !== 'function') {
        return Promise.reject(new Error('clipboard unavailable'));
      }
      return navigatorValue.clipboard.writeText(value);
    },
  };
}
